module.exports = __webpack_public_path__ + "static/media/arrow-down.c18bfbbc.svg";